import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideClientHydration, withEventReplay } from '@angular/platform-browser';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';

import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideStorage, getStorage } from '@angular/fire/storage';
import { loadingInterceptor } from './core/interceptors/loading.interceptor';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
const firebaseConfig = { 
  apiKey: "AIzaSyCKO97rTylVmkt0WOO49g76lTzpf7ztSys",
  authDomain: "newfirebase-21d0f.firebaseapp.com",
  databaseURL: "https://newfirebase-21d0f-default-rtdb.firebaseio.com",
  projectId: "newfirebase-21d0f",
  storageBucket: "newfirebase-21d0f.appspot.com",
  messagingSenderId: "332785188540",
  appId: "1:332785188540:web:51ccdee4adb6635588dab9",
  measurementId: "G-F4VJZRNWPX",
  recaptchaSiteKey :"6LcXjQ4sAAAAAGs3yPUqsdHdwI-wramtYTCogy7_"


};

export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withFetch()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideAnimations() ,
     provideHttpClient(withFetch()),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideClientHydration(withEventReplay()),
    provideHttpClient(withInterceptors([loadingInterceptor])),
    importProvidersFrom(BrowserAnimationsModule),
    provideFirebaseApp(() => initializeApp(firebaseConfig)),
    provideAuth(() => getAuth()),
    provideFirestore(() => getFirestore()),
    provideStorage(() => getStorage()),
    AngularFirestoreModule // ✅ fixed: now it's not nested
   
  ]
};
